<template>
  <div class="bg">
    <div class="content">
      <div class="btn">
        <el-button type="info" @click="quitBtn" size="mini"> 取消 </el-button>
        <el-button type="primary" size="mini" @click="submitForm('infoForm')">
          提交
        </el-button>
      </div>
      <el-form
        ref="infoForm"
        :model="infoForm"
        :rules="rules"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-form-item label="所属项目：" prop="projectId">
            <span @click="showProjectPopup = true">{{ projectId }}</span>
            <van-popup
              v-model="showProjectPopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择所属项目"
                show-toolbar
                :columns="projectOptions"
                @confirm="onConfirmProject"
                @cancel="showProjectPopup = false"
              />
            </van-popup>
          </el-form-item>

          <el-form-item label="设备名称：" prop="name">
            <el-input v-model="infoForm.name" placeholder="请输入设备名称" clearable />
          </el-form-item>
          <el-form-item label="设备编号：" prop="sn">
            <el-input v-model="infoForm.sn" placeholder="请输入设备编号" clearable />
          </el-form-item>
          <el-form-item label="设备型号：" prop="type">
            <span @click="showTypePopup = true">{{ type }}</span>
            <van-popup
              v-model="showTypePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择设备型号"
                show-toolbar
                :columns="typeOptions"
                @confirm="onConfirmType"
                @cancel="showTypePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="进出类型：" prop="inOut">
            <span @click="showInOutPopup = true">{{ inOut }}</span>
            <van-popup
              v-model="showInOutPopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择进出类型"
                show-toolbar
                :columns="inOutOptions"
                @confirm="onConfirmInOut"
                @cancel="showInOutPopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="使用状态：" prop="status">
            <span @click="showStatusPopup = true">{{ status }}</span>
            <van-popup
              v-model="showStatusPopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择使用状态"
                show-toolbar
                :columns="statusOptions"
                @confirm="onConfirmStatus"
                @cancel="showStatusPopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="设备密码：">
            <el-input
              v-model="infoForm.password"
              placeholder="请输入设备密码"
              clearable
              show-password
            />
          </el-form-item>
          <el-form-item label="设备IP：" prop="IP">
            <el-input v-model="infoForm.ip" placeholder="请输入证设备IP" clearable />
          </el-form-item>
          <el-form-item label="生产日期：">
            <span @click="showManufactureDatePopup = true">{{
              infoForm.manufactureDate
            }}</span>
            <van-popup
              v-model="showManufactureDatePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="请选择生产日期"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmManufactureDate"
                @cancel="showManufactureDatePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="安装位置：">
            <el-input
              v-model="infoForm.installPosition"
              placeholder="请输入安装位置"
              clearable
            />
          </el-form-item>
          <el-form-item label="备注信息：" prop="remark">
            <el-input
              v-model="infoForm.remark"
              placeholder="请输入备注信息"
              clearable
              type="textarea"
            />
          </el-form-item>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postListUnit } from "@/api/app/unit";
import { filtration$ } from "@/utils/admin";
import formRules from "@/utils/formRules.js";
import { getProjectList, postProjectId } from "@/api/app/project";
import { postSubmitForm, postDetail } from "@/api/app/equipment";
export default {
  data() {
    var validateIP = (rule, value, callback) => {
      if (value != null && value != "" && !isIp(value)) {
        callback(new Error("ip地址格式错误"));
      } else {
        callback();
      }
    };
    return {
      // 所属项目
      projectOptions: [],
      projectId: "请选择所属项目",
      showProjectPopup: false,
      // 设备型号
      typeOptions: [],
      type: "请选择设备型号",
      showTypePopup: false,
      // 进出类型
      inOutOptions: [],
      inOut: "请选择进出类型",
      showInOutPopup: false,
      // 使用状态
      statusOptions: [],
      status: "请选择使用状态",
      showStatusPopup: false,
      // 时间选择器
      minDate: new Date(new Date().getFullYear() - 2, 1, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showManufactureDatePopup: false,
      infoForm: {
        manufactureDate: "请选择生产日期",
      },
      // 表单验证
      rules: {
        projectId: [{ required: true, message: "所属项目不能为空" }],
        name: [{ required: true, message: "设备名称不能为空" }],
        sn: [{ required: true, message: "设备编号不能为空" }],
        type: [{ required: true, message: "设备型号不能为空" }],
        inOut: [{ required: true, message: "设备进出类型不能为空" }],
        status: [{ required: true, message: "设备使用状态不能为空" }],
        IP: [{ validator: validateIP, trigger: "blur" }],
      },
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    this.options();
    if (this.$route.params.addOrEdit == "1") {
      this.detail();
    }
  },
  methods: {
    options() {
      // if (this.$route.params.addOrEdit == "0") {
      // 所属项目选择项
      getProjectList().then((res) => {
        this.projectOptions = res.data.map((item) => {
          return { text: item.title, ...item };
        });
      });
      // 设备型号选择项
      postDictCode("equipment_model").then((res) => {
        this.typeOptions = res.data.map((item) => {
          return { text: item.label, ...item };
        });
      });
      // 进出类型
      this.inOutOptions = this.$store.state.app.dict.map((item) => {
        return { text: item.label, ...item };
      });
      // 使用状态
      this.statusOptions = [
        { text: "正常", value: 1 },
        { text: "拆除", value: 2 },
      ];
      // }
      this.$store.dispatch("submitToken");
    },
    //   选择所属项目
    onConfirmProject(value) {
      this.projectId = value.text;
      this.infoForm["projectId"] = value.id;
      this.showProjectPopup = false;
    },
    // 选择设备型号
    onConfirmType(value) {
      this.type = value.label;
      this.infoForm["type"] = value.value;
      this.showTypePopup = false;
    },
    // 选择进出类型
    onConfirmInOut(value) {
      this.inOut = value.label;
      this.infoForm["inOut"] = value.value;
      this.showInOutPopup = false;
    },
    // 选择使用状态
    onConfirmStatus(value) {
      this.status = value.text;
      this.infoForm["status"] = value.value;
      this.showStatusPopup = false;
    },
    // 选择生产日期
    confirmManufactureDate(value) {
      this.infoForm.manufactureDate = this.datePick.datePick(value).substring(0, 10);
      this.showManufactureDatePopup = false;
    },
    // 提交表单
    submitForm(infoForm) {
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          postSubmitForm(filtration$(this.infoForm))
            .then((res) => {
              if (this.$route.params.addOrEdit == "0" && res.code == 200) {
                this.$notify({ type: "success", message: "添加成功！" });
                this.$refs["infoForm"].resetFields();
              } else if (this.$route.params.addOrEdit == "1" && res.code == 200) {
                this.$notify({ type: "success", message: "修改成功！" });
                // 暂留
                this.$router.back();
              }
            })
            .catch((error) => {
              this.$store.dispatch("submitToken");
            });
        }
      });
    },
    // 通过列表获取考勤设备详细信息
    detail() {
      postDetail(this.$store.state.app.itemId).then((a) => {
        this.infoForm = a.data;
        // 所属项目
        postProjectId(this.$store.state.app.projectId).then((b) => {
          this.projectId = b.data.name;
        });
        // 设备型号
        postDictCode("equipment_model").then((c) => {
          c.data.find((item) => {
            if (item.value == a.data.type) {
              this.type = item.label;
            }
          });
        });
        // 进出类型
        this.$store.state.app.dict.find((item) => {
          if (item.value == a.data.inOut) {
            this.inOut = item.label;
          }
        });
        // 使用状态
        this.statusOptions.find((item) => {
          if (item.value == a.data.status) {
            this.status = item.text;
          }
        });
      });
    },
    //取消按钮
    quitBtn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  min-height: 100vh;
  margin-bottom: 50px;
  background-color: #f0f0f0;
}

.content {
  padding: 10px;
  .btn {
    text-align: right;
    margin-bottom: 10px;
  }
  /deep/.el-card {
    margin-bottom: 10px;
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-form-item__label {
      padding: 0;
    }
    .el-input__inner {
      border: unset;
      padding: 0;
    }
  }
}
</style>
